import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { NbAuthService } from "@nebular/auth";
import { Router } from "@angular/router";
import { StorageService } from "../../../../shared/services/storage.service";
import { CadastroUsuarioDataService } from "../../../../pages/cadastro/shared/services/CadastroUsuarioController/cadastroUsuario-data.service";
import { UpdatePasswordCommand } from "../models/command/UpdatePasswordCommand";
import { AccountDataService } from "../service/account-data.service";

@Component({
  selector: 'ngx-new-password',
  styleUrls: ['./new-password.component.scss'],
  templateUrl: './new-password.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'full-screen-new-password'
  }
})
export class NgxNewPasswordComponent implements OnInit {
  @ViewChild('newPasswordContainer', { static: true }) newPasswordContainer: ElementRef;
  
  user: any = {
    email: '',
    password: '',
    confirmPassword: ''
  };
  
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  showMessages = {
    error: false,
    success: false
  };
  strategy = 'email';
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private authService: NbAuthService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService,
    private accountDataService: AccountDataService,

  ) {}

  ngOnInit() {
    // Remove qualquer layout padrão do Nebular
    this.removeNebularLayout();
    
    // Verificar se o código foi verificado e carregar email
    this.loadUserData();
    
    this.cd.detectChanges();
  }

  ngAfterViewInit() {
    // Garante que o componente ocupe toda a tela
    this.ensureFullScreen();
  }

  removeNebularLayout() {
    // Remove classes e estilos padrão do Nebular
    const body = document.body;
    body.classList.add('custom-new-password-layout');
    
    // Remove qualquer container padrão do Nebular
    const nebularContainers = document.querySelectorAll('.nb-auth, .auth-block, .auth-container');
    nebularContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.style.display = 'none';
      }
    });
  }

  ensureFullScreen() {
    // Garante que o componente ocupe toda a tela
    if (this.newPasswordContainer) {
      const container = this.newPasswordContainer.nativeElement;
      container.style.width = '100vw';
      container.style.height = '100vh';
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.zIndex = '9999';
    }
  }

  loadUserData() {
    console.log('Verificando dados do usuário para nova senha...');
    
    // Verificar se o código foi verificado
    const codeVerified = this.storageService.getLocalItem('codeVerified');
    const resetPasswordEmail = this.storageService.getLocalItem('resetPasswordEmail');
    
    console.log('codeVerified:', codeVerified, 'resetPasswordEmail:', resetPasswordEmail);
    
    if (!codeVerified || !resetPasswordEmail) {
      console.log('Acesso negado: código não verificado ou email não encontrado');
      // Redirecionar para login se não foi verificado
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 2000);
      return;
    }
    
    this.user.email = resetPasswordEmail;
    console.log('Dados carregados com sucesso para nova senha');
  }

  // Método para alterar senha
  changePassword(): void {
    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    // Validações básicas
    if (this.user.password !== this.user.confirmPassword) {
      this.errors = ['As senhas não coincidem.'];
      this.showMessages.error = true;
      this.submitted = false;
      this.cd.detectChanges();
      return;
    }

    if (this.user.password.length < 6) {
      this.errors = ['A senha deve ter pelo menos 6 caracteres.'];
      this.showMessages.error = true;
      this.submitted = false;
      this.cd.detectChanges();
      return;
    }

    // Implementação real para atualizar senha
    const updatePasswordCommand = new UpdatePasswordCommand({
      email: this.user.email,
      senhaNova: this.user.password
    });

    this.accountDataService.AtualizaSenha(updatePasswordCommand).subscribe({
      next: (result: any) => {
        this.submitted = false;
        if (result.success || result.isSuccess) {
          this.messages = ['Senha alterada com sucesso! Redirecionando para o login...'];
          this.showMessages.success = true;
          
          // Limpar dados do localStorage
          this.storageService.removeLocalItem('resetPasswordEmail');
          this.storageService.removeLocalItem('codeVerified');
          
          setTimeout(() => {
            this.router.navigate(['/auth/login']);
          }, 3000);
        } else {
          const originalErrors = result.getErrors ? result.getErrors() : ['Erro ao alterar senha'];
          this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          this.showMessages.error = true;
        }
        this.cd.detectChanges();
      },
      error: (error) => {
        this.submitted = false;
        this.errors = ['Erro ao alterar senha. Tente novamente.'];
        this.showMessages.error = true;
        this.cd.detectChanges();
      }
    });
  }

  // Métodos para mostrar/ocultar senhas
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // Método para voltar ao login
  goBackToLogin(): void {
    // Limpar dados do localStorage
    this.storageService.removeLocalItem('resetPasswordEmail');
    this.storageService.removeLocalItem('codeVerified');
    this.router.navigate(['/auth/login']);
  }

  /**
   * Traduz mensagens de erro do inglês para português
   */
  private translateErrorMessage(error: string): string {
    const errorTranslations: { [key: string]: string } = {
      'Password is required': 'Senha é obrigatória',
      'Password too short': 'Senha muito curta',
      'Passwords do not match': 'As senhas não coincidem',
      'Password must contain at least one uppercase letter': 'A senha deve conter pelo menos uma letra maiúscula',
      'Password must contain at least one lowercase letter': 'A senha deve conter pelo menos uma letra minúscula',
      'Password must contain at least one number': 'A senha deve conter pelo menos um número',
      'Password must contain at least one special character': 'A senha deve conter pelo menos um caractere especial',
      'Email is required': 'E-mail é obrigatório',
      'Invalid email format': 'Formato de e-mail inválido',
      'User not found': 'Usuário não encontrado',
      'Account is locked': 'Conta está bloqueada',
      'Account is disabled': 'Conta está desabilitada',
      'Session expired': 'Sessão expirada',
      'Network error': 'Erro de conexão',
      'Server error': 'Erro do servidor'
    };

    // Procura por uma tradução exata
    if (errorTranslations[error]) {
      return errorTranslations[error];
    }

    // Procura por traduções parciais
    for (const [english, portuguese] of Object.entries(errorTranslations)) {
      if (error.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return error;
  }

  getConfigValue(key: string): any {
    return true;
  }
}
